export const finishSteps = [
    {
        identifier: 'FinishStep.Cancel',
        description: "Finish Survey > Cancel"
    },
    {
        identifier: 'FinishStep.CancelAndSave',
        description: "Finish Survey > Cancel and Save"
    },
    {
        identifier: 'FinishStep.CancelAndDiscard',
        description: "Finish Survey > Cancel and Discard"
    },
    {
        identifier: 'FinishStep.Complete',
        description: "Finish Survey > Complete and Submit Results"
    }
];

export function getFinishStep(identifier: string) {
    return finishSteps.find(s => s.identifier === identifier);
}
